module.exports = __webpack_public_path__ + "img/anleitung.c4512054.svg";